import LayoutContainer from 'components/Common/LayoutContainer'
import MarkdownRender from 'LuxKit/MarkdownRender'
import Heading from 'LuxKit/Typography/Heading'
import Accordion from 'LuxKit/Accordion'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  title: string
  content: Array<App.LegalItem>
}

function HubLegal(props: Props) {
  return (
    <LayoutContainer size="sm">
      <Heading as="h2" variant="heading2">{props.title}</Heading>
      <VerticalSpacer gap={16}>
        {props.content.map((item) => (<>
          {item.type === 'legalTermAndCondition' && (
            <VerticalSpacer gap={24} key={item.fields.slug} id={item.fields.slug}>
              <Heading as="h2" variant="heading2">{item.fields.title}</Heading>
              <MarkdownRender content={item.fields.description} />
            </VerticalSpacer>
          )}
          {item.type === 'legalPageFaq' && (
            <Accordion
              key={item.fields.slug}
              heading={item.fields.title}
              id={item.fields.slug}
            >
              <MarkdownRender content={item.fields.answer} />
            </Accordion>
          )}
        </>))}
      </VerticalSpacer>
    </LayoutContainer>
  )
}

export default HubLegal
